<template>
    <section id="contact">
        <div class="container" style="text-align: center">
            <h2>Kontakt</h2>

            <div>
                <p>
                    Softresource, spol. s r.o.
                    <br>
                    IČ: 066 14 329
                    <br>
                    Příkop 838/6, BRNO 602 00
                </p>
                <p>
                    vedená u Krajského soudu v Brně
                    <br>
                    pod spisovou značkou C 103195
                </p>
                <p>
                    <a href="mailto:analytics@softresource.cz" class="external">analytics@softresource.cz</a>
                    <br>
                    <a href="http://www.softresource.cz/" class="external" target="_blank">www.softresource.cz</a>
                    <br>
                    <a href="http://www.futurebooks.cz/" class="external" target="_blank">www.futurebooks.cz</a>
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {

    }
</script>

<style>
    #contact {
        color: #fff;
    }

    #contact a {
        color: #fff;
    }
</style>